// Essential reducers - loaded immediately (required for app initialization)
import LayoutReducer from "./layouts/reducer";
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";
import UsersReducer from "./users/reducer";
import RolesReducer from "./roles/reducer";
import DashboardEcommerceReducer from "./dashboardEcommerce/reducer";

// Initial reducers - only essential ones for app startup
const initialReducers = {
    Layout: LayoutReducer,
    Login: LoginReducer,
    Account: AccountReducer,
    ForgetPassword: ForgetPasswordReducer,
    Profile: ProfileReducer,
    Users: UsersReducer,
    Roles: RolesReducer,
    DashboardEcommerce: DashboardEcommerceReducer,
};

// Lazy reducer loaders - functions that return promises
export const lazyReducers = {
    // Fruits
    Fruits: () => import("./fruits/reducer").then(module => module.default),

    // Fruits Subtypes
    FruitsSubtypes: () => import("./fruitsSubtypes/reducer").then(module => module.default),

    // Parties
    Parties: () => import("./parties/reducer").then(module => module.default),

    // Invoice settings
    invoiceTypes: () => import("./invoiceTypes/reducer").then(module => module.default),
    invoiceSubtypes: () => import("./invoiceSubtypes/reducer").then(module => module.default),
    invoiceParticulars: () => import("./invoiceParticulars/reducer").then(module => module.default),
    shippingPorts: () => import("./shippingPorts/reducer").then(module => module.default),

    // Import
    Containers: () => import("./containers/reducer").then(module => module.default),
    containerInvoices: () => import("./containerInvoices/reducer").then(module => module.default),

    // Export - current stock
    stock: () => import("./stock/reducer").then(module => module.default),
};

export { initialReducers };
export default initialReducers;
